// Smooth scroll utilities
export function smoothScrollTo(element, offset = 0) {
  if (typeof element === 'string') {
    element = document.querySelector(element);
  }
  
  if (!element) return;
  
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - offset;
  
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}

// Handle anchor link clicks
export function initSmoothScroll(offset = 80) {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (href === '#' || href === '#!') return;
    
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      smoothScrollTo(target, offset);
    }
  });
}

// Check if smooth scroll is supported
export function supportsSmoothScroll() {
  return 'scrollBehavior' in document.documentElement.style;
}

// Polyfill for older browsers
if (!supportsSmoothScroll()) {
  // Simple polyfill using requestAnimationFrame
  const originalScrollTo = window.scrollTo;
  window.scrollTo = function(options) {
    if (options && options.behavior === 'smooth') {
      const start = window.pageYOffset;
      const target = typeof options.top === 'number' ? options.top : start;
      const distance = target - start;
      const duration = 600;
      let startTime = null;
      
      function animate(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        
        // Easing function (ease-out)
        const ease = 1 - Math.pow(1 - progress, 3);
        
        window.scrollTo(0, start + distance * ease);
        
        if (timeElapsed < duration) {
          requestAnimationFrame(animate);
        }
      }
      
      requestAnimationFrame(animate);
    } else {
      originalScrollTo.call(this, options);
    }
  };
}











